// ----
// Social Cobalt JS
// ----
(function ($, Cobalt, undefined) {
    Cobalt.Social_Facebook = {
        isLoaded:false,
        initialize: function () {

            window.fbAsyncInit = function () {
                FB.init({
                    appId: Cobalt.Constants.FacebookAppID, // App ID                    
                    status: true, // check login status
                    cookie: true, // enable cookies to allow the server to access the session
                    xfbml: false  // parse XFBML
                });

                if (window._ga != null) {
                    window._ga.trackFacebook();
                }

                $(Cobalt.Social_Facebook).trigger("facebookLoaded");
            };
           
            var d = document;
            var js, id = 'facebook-jssdk';
            if (d.getElementById(id)) { return; }
            js = d.createElement('script'); js.id = id; js.async = true;
            js.src = "//connect.facebook.net/en_US/all.js";
            js.defer = true;
            d.getElementsByTagName('head')[0].appendChild(js);
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Social_Facebook.js